<template>
  <div>
    <!-- if 有子节点，渲染节点递归 -->
    <template v-if="item.children">
      <el-submenu v-if="!(item.path != '' && item.path != ' ' && item.path != '-') && !item.IsButton"
        :index="item.id + 'index'" :key="item.path">
        <template slot="title">
          <i v-if="item.children && item.children.length > 0 && item.iconCls && !item.IsButton" class="fa menu-fa-icon"
            :class="item.iconCls"></i>
          <span class="title-name" slot="title">{{ item.name }}</span>
        </template>
        <template v-for="child in item.children">
          <!-- 按钮权限挂在页面下时不要当子菜单递归，否则进页可能异常卡死 -->
          <template v-if="!child.IsHide && !child.IsButton && !item.IsButton">
            <sidebar
              v-if="hasRealMenuChildren(child)"
              :item="child"
              :index="child.id"
              :key="child.id || child.path"
            />
            <template v-else>
            <app-link v-if="isExternalLink(child.path)" :to="child.path" :key="child.path + '-ext'">
              <el-menu-item :index="''" @click="cop"
                class="menu-item-with-star">
                <!-- 有 iconCls 显示对应图标；无则显示默认文档图标，避免图标列空白 -->
                <i v-if="child.iconCls" class="fa menu-fa-icon" :class="child.iconCls"></i>
                <i v-else class="el-icon-document menu-icon-default"></i>
                <template slot="title">
                  <span class="title-name">{{ child.name }}</span>
                </template>
                <!-- ⭐️ 星标：position:absolute 钉在行最右侧，不受 title slot 宽度限制 -->
                <span v-if="$store.state.sysLayoutMode === 'portal'" class="star-icon-wrapper"
                  @click.prevent.stop="toggleStar(child.id)">
                  <i :class="isStarred(child.id) ? 'el-icon-star-on starred' : 'el-icon-star-off unstarred'"></i>
                </span>
              </el-menu-item>
            </app-link>
            <el-menu-item v-else :key="child.path" :index="child.path" @click="cop"
              class="menu-item-with-star">
              <!-- 有 iconCls 显示对应图标；无则显示默认文档图标，避免图标列空白 -->
              <i v-if="child.iconCls" class="fa menu-fa-icon" :class="child.iconCls"></i>
              <i v-else class="el-icon-document menu-icon-default"></i>
              <template slot="title">
                <span class="title-name">{{ child.name }}</span>
              </template>
              <!-- ⭐️ 星标：position:absolute 钉在行最右侧，不受 title slot 宽度限制 -->
              <span v-if="$store.state.sysLayoutMode === 'portal'" class="star-icon-wrapper"
                @click.prevent.stop="toggleStar(child.id)">
                <i :class="isStarred(child.id) ? 'el-icon-star-on starred' : 'el-icon-star-off unstarred'"></i>
              </span>
            </el-menu-item>
            </template>
          </template>
        </template>
      </el-submenu>
      <template v-else>
        <app-link v-if="isExternalLink(item.path)" :to="item.path" :key="item.path + 'd-ext'">
          <el-menu-item :index="''" :key="item.path + 'd'"
            class="menu-item-with-star">
            <i v-if="item.iconCls" class="fa menu-fa-icon" :class="item.iconCls"></i>
            <i v-else class="el-icon-document menu-icon-default"></i>
            <template slot="title">
              <span class="title-name">{{ item.name }}</span>
            </template>
            <span v-if="$store.state.sysLayoutMode === 'portal'" class="star-icon-wrapper"
              @click.prevent.stop="toggleStar(item.id)">
              <i :class="isStarred(item.id) ? 'el-icon-star-on starred' : 'el-icon-star-off unstarred'"></i>
            </span>
          </el-menu-item>
        </app-link>
        <el-menu-item v-else :index="item.path" :key="item.path + 'd'"
          class="menu-item-with-star">
          <i v-if="item.iconCls" class="fa menu-fa-icon" :class="item.iconCls"></i>
          <i v-else class="el-icon-document menu-icon-default"></i>
          <template slot="title">
            <span class="title-name">{{ item.name }}</span>
          </template>
          <span v-if="$store.state.sysLayoutMode === 'portal'" class="star-icon-wrapper"
            @click.prevent.stop="toggleStar(item.id)">
            <i :class="isStarred(item.id) ? 'el-icon-star-on starred' : 'el-icon-star-off unstarred'"></i>
          </span>
        </el-menu-item>
      </template>
    </template>
    <!-- else 没有子节点，直接输出 -->
    <template v-else>
      <app-link v-if="isExternalLink(item.path)" :to="item.path" :key="item.path + 'd-ext'">
        <el-menu-item :index="''" :key="item.path + 'd'" @click="cop"
          class="menu-item-with-star">
          <i v-if="item.iconCls" class="fa menu-fa-icon" :class="item.iconCls"></i>
          <i v-else class="el-icon-document menu-icon-default"></i>
          <template slot="title">
            <span class="title-name">{{ item.name }}</span>
          </template>
          <span v-if="$store.state.sysLayoutMode === 'portal'" class="star-icon-wrapper"
            @click.prevent.stop="toggleStar(item.id)">
            <i :class="isStarred(item.id) ? 'el-icon-star-on starred' : 'el-icon-star-off unstarred'"></i>
          </span>
        </el-menu-item>
      </app-link>
      <el-menu-item v-else :index="item.path" :key="item.path + 'd'" @click="cop"
        class="menu-item-with-star">
        <i v-if="item.iconCls" class="fa menu-fa-icon" :class="item.iconCls"></i>
        <i v-else class="el-icon-document menu-icon-default"></i>
        <template slot="title">
          <span class="title-name">{{ item.name }}</span>
        </template>
        <span v-if="$store.state.sysLayoutMode === 'portal'" class="star-icon-wrapper"
          @click.prevent.stop="toggleStar(item.id)">
          <i :class="isStarred(item.id) ? 'el-icon-star-on starred' : 'el-icon-star-off unstarred'"></i>
        </span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import AppLink from "./AppLink";
import { isExternal } from "../../util/validate";
import { saveUserConfig } from '../api/modules/misc';

export default {
  name: "Sidebar",
  components: { AppLink },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    isExternalLink(to) {
      return isExternal(to);
    },
    /** 是否还有真正的子菜单（排除 IsButton 权限按钮） */
    hasRealMenuChildren(node) {
      const children = (node && node.children) || [];
      return children.some(c => c && !c.IsButton && !c.IsHide);
    },
    cop: function () {
      // 子组件中触发父组件方法collaFa并传值123
      this.$emit("collaFa", "123");
    },
    // 检查当前子菜单是否已经被星标收藏（ID 统一字符串比较）
    isStarred(menuId) {
      const sid = menuId != null ? String(menuId) : '';
      const shortcuts = this.$store.state.myShortcutIds || [];
      return shortcuts.some(id => String(id) === sid);
    },
    // 点击切换星标状态并静默持久化至云端
    toggleStar(menuId) {
      if (menuId == null) return;
      const sid = String(menuId);
      let shortcuts = (this.$store.state.myShortcutIds || []).map(id => String(id));

      if (shortcuts.includes(sid)) {
        // 取消收藏
        shortcuts = shortcuts.filter(id => id !== sid);
      } else {
        // 新增收藏（上限8个控制）
        if (shortcuts.length >= 8) {
          this.$message.warning('常用功能最多只能添加 8 个！');
          return;
        }
        shortcuts.push(sid);
      }

      // 1. 同步更新 Vuex 全局状态和本地缓存
      this.$store.commit('saveShortcutIds', shortcuts);

      // 2. 静默提交至后端 UserConfig 表保存（按真实用户 ID 存储）
      const userStr = window.localStorage.getItem('user');
      const uId = userStr ? (JSON.parse(userStr).uID || 0) : 0;
      if (uId > 0) {
        saveUserConfig({
          userId: uId,
          configKey: 'shortcuts',
          configValue: JSON.stringify(shortcuts)
        }).catch(err => {
          console.error('星标状态同步云端失败', err);
        });
      }
    }
  }
};
</script>

<style scoped>
/* el-menu-item 设为 relative，为星标 absolute 定位提供基准 */
.menu-item-with-star {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
}

/* 默认文档图标（无 iconCls 时），颜色与 fa 图标保持一致，尺寸偏小 */
.menu-icon-default {
  font-size: 13px !important;
  color: #909399;
  line-height: 1 !important;
  vertical-align: middle;
}

.menu-fa-icon {
  color: #9099a6;
  transition: color 0.2s ease;
}

.menu-item-with-star:hover .menu-fa-icon,
.el-submenu__title:hover .menu-fa-icon {
  color: #d6dce6;
}

.el-menu-item.is-active .menu-fa-icon,
.el-submenu.is-active > .el-submenu__title .menu-fa-icon,
.el-submenu.is-active .el-menu-item.is-active .menu-fa-icon {
  color: #ffd04b !important;
}

.el-menu-item.is-active .title-name,
.el-submenu.is-active > .el-submenu__title .title-name {
  color: #ffd04b !important;
}


/* 菜单行内图标与标题同一中线。最后更新：2026-07-26 */
.menu-item-with-star > i,
.el-submenu__title > i {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 20px !important;
  margin-right: 10px !important;
  line-height: 1 !important;
  vertical-align: middle !important;
}

.title-name {
  display: inline-flex !important;
  align-items: center !important;
  line-height: 1.2 !important;
  vertical-align: middle;
}

/* ⭐️ 星标：absolute 定位，始终钉在菜单行最右侧 */
.star-icon-wrapper {
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  cursor: pointer;
  border-radius: 4px;
  z-index: 10;
  transition: background-color 0.18s ease;
}

.star-icon-wrapper:hover {
  background-color: rgba(255, 208, 75, 0.12);
}

/* 实心金色：已收藏状态，始终可见 */
.star-icon-wrapper i.starred {
  color: #ffd04b !important;
  font-size: 15px;
}

/* 空心灰色：未收藏状态，默认透明隐藏 */
.star-icon-wrapper i.unstarred {
  color: #909399 !important;
  font-size: 15px;
  opacity: 0;
  transition: opacity 0.18s ease, color 0.18s ease;
}

/* 鼠标悬浮到整行时，空心星标半透明浮现 */
.menu-item-with-star:hover .star-icon-wrapper i.unstarred {
  opacity: 0.5;
}

/* 鼠标直接悬浮到星标时，完全点亮为金色 */
.star-icon-wrapper:hover i.unstarred {
  opacity: 1 !important;
  color: #ffd04b !important;
}
</style>
